
<div class="absolute bg-white h-full w-full top-0 left-0 flex justify-content-center align-items-center">
  <i class="pi pi-spin pi-cog mr-2 text-co" style="font-size: 2rem"></i>
  <p>Loading Account</p>
</div>
